<template>
  <div class="page-content">
    <!-- mobile view Searching -->
    <div class="Searching_input_box_mobile_view position-relative">
      <div class="w-100  mb-3 " v-if="this.show">
        <input type="text" v-model="input" :disabled="searchDisable" @keyup.enter="searchregionname(input)"
          placeholder="Search..." />
      </div>
    </div>
    <div class="mb-2 mt-1">
      <span style="font-size: 20px;">
        Token Management
      </span>
      <span class="float-end d-flex">

        <!-- Filter Logs for displaying ALocated or Consumption Or All logs -->
        <!-- <div class="filter-container Group_top_three_dot">
          <button @click="toggleFilter()" class="btn bg-white shadow p-2 mx-2  rounded-circle ">
            <img src="../../../public/dashboard-assets/images/M2/Filter_icon.png" style="" />
          </button>

          <div v-if="showFilter" class="filter-popup shadow-sm">
            <div class="modal-header">
              <h4 class="modal-title text-centerm-auto" id="CreateGroupModalLabel">
                Filter Logs
              </h4>
              <button @click="closeFilter()" type="button" class="btn-close"></button>
            </div>

            <div class="tab-content" id="pills-tabContent">

              <div class=" p-1 d-flex flex-column">
                <ul class="list-unstyled px-2 mb-4 ">
                  <li v-for="option in filterOptions" :key="option" class="py-2">
                    <input type="radio" :id="option" :value="option" v-model="selectedFilter" class="me-2" />
                    <h5 class="d-inline " :for="option">{{ option }}</h5>
                  </li>
                </ul>
                <div class="text-end mb-2 me-2">
                  <button type="button" class="btn-Apply-kj-color" v-if="selectedFilter" @click="clearFilter()">
                    Clear
                  </button>
                  <button type="button" class="modail_submit_button text-end mb-2"
                    :class="{ active_form_button: selectedFilter }" :disabled="!selectedFilter" @click="applyFilter()">
                    Apply
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div> -->
        <div class="card is-loading mx-2" v-if="this.CardLoader == true"
          style="border-radius: 999px; width: 40px; height: 40px;">
        </div>
        <div class="top_heading_CreatePartner_btn top_heading_CreatePartner_btn-kj d-block mx-2" v-else>
          <div class="Group_top_three_dot" id="tour-filter-web-icon">
            <div class="dropdown">
              <button class="btn p-0 Group_top_three_dot_dropdown position-relative" type="button"
                id="dropdownMenuButton1" data-bs-toggle="dropdown" data-bs-auto-close="outside" aria-expanded="false"
                aria-haspopup="true" style="line-height: 0.3">
                <img src="../../../public/dashboard-assets/images/M2/Filter_icon.png" style="" />

                <span class="Noti-alert-kj translate-middle" v-if="this.applyfilter > 0">
                  {{ this.applyfilter }} <span class="visually-hidden"></span>
                </span>
              </button>

              <ul class="dropdown-menu dropdown-menu-kj dropdown-menu-kj-w" aria-labelledby="dropdownMenuButton1">
                <div class="modal-header">
                  <h4 class="modal-title text-centerm-auto" id="CreateGroupModalLabel">
                    Filter
                  </h4>
                  <button @click="closeFilter()" type="button" class="btn-close"></button>
                </div>

                <ul class="nav nav-pills mb-3 nav-fill" id="pills-tab" role="tablist">

                  <li class="nav-item" role="presentation">
                    <button class="nav-link text-muted text-center active" id="pills-profile-tab" data-bs-toggle="pill"
                      @click="
                        this.filterTab = 2;
                      " data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile"
                      aria-selected="false">
                      Logs
                    </button>
                  </li>
                  <li class="nav-item" role="presentation">
                    <button class=" nav-link text-muted text-center " id="pills-home-tab" @click="
                      this.filterTab = 1;
                    this.searchfilter = '';
                    this.Filterresult();
                    " data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab"
                      aria-controls="pills-home" aria-selected="true">

                      Partner
                    </button>
                  </li>
                </ul>
                <div class="tab-content" id="pills-tabContent">
                  <div class="tab-pane fade   p-0" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                    <div class="search-bar">
                      <form class="search-form">
                        <input type="text" v-model="searchfilter" @keyup="Filterresult" placeholder="Search"
                          class="form-control bg-white" /><button class="btn">
                          <i class="fas fa-search"></i>
                        </button>
                      </form>
                      <div class="ul-li-checkbox-kj">
                        <ul>
                          <li v-for="item in partners" :key="item">
                            <input type="checkbox" :value="item" name="" @change="addFilter(item.clientId, $event)"
                              :checked="this.filters.partners.includes(item.clientId)
                                " />
                            <span>{{ item.company }}</span>
                          </li>
                        </ul>
                        <div class="text-end">
                          <button type="button" class="btn-Apply-kj-color" v-if="this.applyfilter > 0"
                            @click="clearFilter()">
                            Clear Filter
                          </button>

                          <button type="button" class="modail_submit_button text-end" :class="{
                            active_form_button: this.applyfilter > 0,
                          }" :disabled="applyfilter == 0" @click="applyFilter()">
                            Apply
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="tab-pane fade active show p-0" id="pills-profile" role="tabpanel"
                    aria-labelledby="pills-profile-tab">
                    <!-- <div class="search-bar">
                      <form class="search-form">
                        <input type="text" v-model="searchfilter" @keyup="Filterresult" placeholder="Search"
                          class="form-control bg-white" /><button class="btn">
                          <i class="fas fa-search"></i>
                        </button>
                      </form>

                     
                    </div> -->
                    <div class="tab-content" id="pills-tabContent">

                      <div class=" p-1 d-flex flex-column">
                        <ul class="list-unstyled px-2 mb-4 ">
                          <li v-for="option in filterOptions" :key="option" class="py-2">
                            <input type="radio" :id="option" :value="option" v-model="selectedFilter" class="me-2" style="transform: scale(1.4);"/>
                            <h5 class="d-inline " :for="option">{{ option }}</h5>
                          </li>
                        </ul>
                        <div class="text-end mb-2 me-2">
                          <button type="button" class="btn-Apply-kj-color" v-if="selectedFilter" @click="clearFilter()">
                            Clear
                          </button>
                          <button type="button" class="modail_submit_button text-end mb-2"
                            :class="{ active_form_button: selectedFilter }" :disabled="!selectedFilter"
                            @click="applyFilter()">
                            Apply
                          </button>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="tab-pane fade p-0" id="pills-profile1" role="tabpanel"
                    aria-labelledby="pills-profile-tab">
                    <!-- <div class="search-bar">
                     

                      <form class="search-form">
                        <input type="text" v-model="searchfilter" @keyup="Filterresult" placeholder="Search"
                          class="form-control bg-white" /><button class="btn">
                          <i class="fas fa-search"></i>
                        </button>
                      </form>
                    </div> -->
                    <!-- <div class="ul-li-checkbox-kj">
                      <ul>
                        <li v-for="invi in InvigilationList" :key="invi">
                          <input type="checkbox" :value="invi.key" name="" @change="addFilter(invi.key, $event)"
                            :checked="this.filters.invigilation.includes(invi.key)
                              " />
                          <span>{{ invi.value }}</span>
                        </li>
                       
                      </ul>
                      <div class="text-end">
                        <button type="button" class="btn-Apply-kj-color" v-if="this.applyfilter > 0"
                          @click="clearFilters()">
                          Clear Filter
                        </button>

                        <button type="button" class="modail_submit_button text-end"
                          :class="{ active_form_button: this.applyfilter > 0 }" :disabled="applyfilter == 0"
                          @click="applyFilters()">
                          Apply
                        </button>

                      </div>
                  
                    </div> -->
                  </div>
                </div>
              </ul>
              <!-- </div> -->
            </div>
          </div>
        </div>

        <!-- Date Range Picker -->
        <span class="top_heading_CreatePartner_btn d-block">
          <div class="Group_top_three_dot">
            <div class="dropdown">
              <button class="btn p-0 Group_top_three_dot_dropdown" type="button">
                <img src="../../../public/dashboard-assets/images/M2/date-icon.png" @click="opencal"
                  data-bs-toggle="tooltip" data-bs-placement="top" title="Filter by Date" />
                <span class="cal-alert translate-middle" v-if="this.fromDate != 0">
                  <span class="visually-hidden"></span>
                </span>
                <input type="text" name="daterange" hidden="true" id="calendar_icon" class="fade" />
              </button>
            </div>
          </div>
        </span>
      </span>
    </div>


    <div class="row">
      <div class="col-xl-8 col-lg-8 partners_top_menu_section_hp">
        <div class="row">
          <div class="col-3">
            <router-link :to="{ name: 'TestManagement' }" class="w-100 btn">
              Overview <span v-if="this.TokelistTotallength > 0">({{ TokelistTotallength }})</span>
            </router-link>
          </div>
          <div class="col-3" v-if="this.showTokenManagement">
            <router-link :to="{ name: 'TokenmanagementViewTest' }" class="w-100 btn">
              View Test
            </router-link>
          </div>
          <div class="col-3" v-if="this.showTokenManagement">
            <router-link :to="{ name: 'TokenmanagementViewRegion' }" class="w-100 btn">
              View Group
            </router-link>
          </div>
          <div class="col-3">
            <router-link :to="{ name: 'TokenLogs' }" class="w-100 btn active btn-outline-primary btn-icon-text">
              View Logs
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- Total Token Transaced count -->
    <div class="row mt-3 ms-lg-1">
      <div class="col-xl-8 col-lg-8 partners_top_menu_section_hp fs-5 w-auto fs-sm-5 fs-md-3 fs-lg-2">
        <span class="d-inline-block me-2 me-md-2 me-sm-0">From: {{ timeZoneConvertDate(fromDate) }}</span>
        <span class="d-inline-block me-2 me-md-2 me-sm-0 ">To: {{ timeZoneConvertDate(toDate) }}</span>
        <span class="d-inline-block me-2 me-md-2 me-sm-0 ">Total Allocated: {{ tokensAllocatedCount }}</span>
        <span class="d-inline-block ">Total Consumed: {{ tokensConsumedCount }}</span>
      </div>
    </div>

    <div class="container mt-2 ms-2 ms-sm-2 ms-md-3 ms-lg-6 " v-if="tokenLogs.length > 0">
      <div class="row" v-for="(item) in tokenLogs" :key="item">

        <div class="col-auto text-center flex-column d-none d-sm-flex">
          <div class="row h-50">
            <div class="col border-end border-info">&nbsp;</div>
            <div class="col border-info">&nbsp;</div>
          </div>

          <!-- The timestamp on the left of the cards -->

          <h5 class=" d-flex flex-column align-items-center">
            <span class="badge rounded-pill p-2"
              :class="item.transactionType === 'allocation' ? 'bg-success opacity-75' : 'bg-danger opacity-75'">
              {{ item.transactionType == 'allocation' ? 'Allocated' : 'Consumed' }}
            </span>

            <div class="text-center d-inline-block py-md-1 py-lg-2" style="min-width: 150px;">
              {{ timeZoneConvertDate(item.createdDate) }}
            </div>
            <div class="text-center d-inline-block" style="min-width: 150px;">
              {{ timeZoneConvertTime(item.createdDate) }}
            </div>
          </h5>

          <div class="row h-50">
            <div class="col border-end border-info">&nbsp;</div>
            <div class="col border-info">&nbsp;</div>
          </div>
        </div>
        <div class="col col-10 col-sm-12 col-md-8 col-lg-8 py-2 ">
          <div class="card shadow border-1 rounded-3 "
            :class="item.transactionType === 'allocation' ? 'border-success' : 'border-danger'">
            <div class="card-body">

              <!-- the transactionType tag only in small screens -->
              <span
                class="position-absolute top-0 d-block d-md-none p-1 mb-2 text-white ms-n4 round-top-left-bottom-right opacity-75"
                :class="item.transactionType === 'allocation' ? 'bg-success' : 'bg-danger'">
                {{ item.transactionType == 'allocation' ? 'Allocated' : 'Consumed' }}
              </span>
              <!-- the date and time only in screens -->
              <div class="d-block d-md-none pb-2 mt-2"
                :class="item.transactionType === 'allocation' ? 'text-success' : 'text-danger'">
                {{ timeZoneConvertDate(item.createdDate) }} {{ timeZoneConvertTime(item.createdDate) }}
              </div>

              <h4 class="card-title" :class="item.transactionType === 'allocation' ? 'text-success' : 'text-danger'">
                <strong> {{ item.itemTypeStr }} : {{ item.itemName }}</strong>

              </h4>
              <p class="card-text">{{ item.action }}</p>

              <div class="pt-2 ">
                <!-- <span class="d-inline-block me-3">Previous Remaining :
                  <span class="fw-bolder">
                    {{ item?.oldRemainingCount == null ? 'N/A' : Number(item.oldRemainingCount).toLocaleString('en-IN')}}
                  </span>
                </span> -->
                <span class="me-5 me-md-3 me-lg-3 d-inline-block">Tokens:
                  <span class="fw-bolder">
                    {{ Number(item.token).toLocaleString('en-IN') }}
                  </span>
                </span>
                <span class="d-inline-block"> {{ item.newRemainingCount == null ? '' : 'New Remaining:' }}
                  <span class="fw-bolder">
                    {{ item.newRemainingCount == null ? '' : Number(item.newRemainingCount).toLocaleString('en-IN')
                    }}
                  </span>
                </span>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="text-center" v-else>
      <img src="../../../public/dashboard-assets/images/M2/empty_record.png" style="width: 20%" class="my-5" />
      <h3 class="ms-5 mt-2">No Details Found</h3>
    </div>
    <!--container-->
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import moment from "moment";
import { superadmin } from "../../utils/helper";
import { SetClarityData } from "../../platformFeatures/featureUtils";

export default {
  name: "TestManagement",
  components: {

  },
  data() {
    return {
      // tokenList: [],
      // reqList: [],
      // Status: "",
      // page: 1,
      // limit: 8,
      // search: "",
      // partners: "",
      // Page_count: 1,
      // modalData: "",
      // parentCompany: "",
      // CompanyName: "",
      // balanceToken: 0,
      // remainingToken: 0,
      // viewData: [],
      // listData: "",
      // groupData: [],
      // reqId: "",
      // offset: 8,
      // redtext: false,
      // isActive: true,
      // approvedReq: [],
      // tokenamt: "",
      // result: [],
      // input: "",
      // show: false,
      // currentPage: 1,
      // company: [],
      // filters: {
      //   company: "",
      // },
      // viewclientId: "",
      // tokenAllocationObj: {},
      // parentTokenAllocationObj: {},
      // screenWidth: 0,
      // approveData: [],
      // firstname: "",
      // lastname: "",
      // amt: "",
      clientid: "",
      partnerId: "",
      applyfilter: 0,
      // parentCompanyName: "",
      // photo: '',
      // searchDisable: false,
      tokenLogs: [],
      billing: JSON.parse(localStorage.getItem('billingData')),
      showTokenManagement: true,
      showFilter: false,
      selectedFilter: '',
      filterOptions: ['Allocation', 'Consumption'],
      tokensAllocatedCount: 0,
      tokensConsumedCount: 0,
      partners: [],
      partnersFilter: [],
      searchfilter: "",
      filters: {
        partners: [],
        logs: [],
      },
      fromDate: null,
      toDate: null
    };
  },
  async created() {
    window.addEventListener("resize", this.myEventHandler);
    this.screenWidth = window.outerWidth;

    if (this.user.isEnterprise == false && this.billing.object.data.plan.planName) {
      this.showTokenManagement = false;
    }

    await this.GetTokenLogsDetail();
    await this.PartnerList();
  },

  async mounted() {
    this.tokenLogs = [];
    SetClarityData();

    var company = await this.Companyheader({
      clientId: this.clientId,
    });
    this.companyName = company.object.data.companyName;
    var photo = company.object.data.profileImage;
    if (photo != null) {
      var resp = await this.companylogo({
        fileName: photo,
      });
      this.photo = resp.object.data;
    } else {
      this.photo = null;
    }
    if (this.$route.query.offset && this.$route.query.current) {
      this.page = parseInt(window.atob(this.$route.query.offset));
      this.currentPage = parseInt(window.atob(this.$route.query.current));
    }
    this.screenWidth = window.outerWidth;
    // await this.getData();
    // await this.GetToken();


    window.$('input[name="daterange"]').daterangepicker(
      {
        maxDate: new Date(),
        locale: { cancelLabel: "Clear" },
        opens: "center",
      },
      async (start, end) => {
        if (start && end) {
          var x = start.format("YYYY-MM-DD 00:00:00");
          var y = end.format("YYYY-MM-DD 00:00:00");
          // this.fromDate = this.dateformat(x);
          // this.toDate = this.todateformat(y);
          this.fromDate = x;
          this.toDate = y;
          this.showw = false;
        }
      }
    );
    window
      .$('input[name="daterange"]')
      .on("cancel.daterangepicker", async (ev, picker) => {
        picker.endDate._d = new Date();
        var endDate = moment(String(picker.endDate._d)).add(1, 'days').format("YYYY-MM-DD  00:00:00");
        var startDate = moment(endDate, "YYYY-MM-DD").subtract(1, 'months').format("YYYY-MM-DD  00:00:00");
        this.fromDate = startDate;
        this.toDate = endDate;
        // await this.Graphical(this.fromDate, this.toDate);
        window.$('input[name="daterange"]').val("");
        this.TokenLogDetails(this.filters.partners.join(','), this.fromDate, this.toDate)
      });
    window
      .$('input[name="daterange"]')
      .on("apply.daterangepicker", async (ev, picker) => {
        var x = moment(String(picker.startDate._d)).format("YYYY-MM-DD 00:00:00");
        var y = moment(String(picker.endDate._d)).format("YYYY-MM-DD 23:59:59");
        var start = moment(String(picker.startDate._d)).format("YYYY-MM-DD 00:00:00")
        var end = moment(String(picker.endDate._d)).format("YYYY-MM-DD 23:59:59")
        if (
          Math.ceil(
            Math.abs(new Date(start) - new Date(end)) /
            (1000 * 60 * 60 * 24)
          ) <=
          6 * 30
        ) {
          this.fromDate = x;
          this.toDate = y;
          this.TokenLogDetails(this.filters.partners.join(','),this.fromDate, this.toDate)
          // if (this.opencals == false) {
          //   await this.Graphical(start, end);
          // }
        } else {
          return this.ShowWarningMessage("Please select range within 6 months");
        }

      });




  },

  computed: {
    ...mapState({
      authenticated: (state) => state.auth.authenticate,
      user: (state) => state.auth.user,
      clientId: (state) => state.auth.user.clientId,
      PartnerId: (state) => state.auth.user.PartnerId,
    }),

  },

  methods: {
    ...mapActions([
      // "GetTokenAllocation",
      // "requestedTokens",
      // "IncrOrDecTokens",
      // "rejectReq",
      // "GetTAllocation",
      // "viewtestList",
      // "viewGroupsList",
      // "AllocateTokenAmount",
      "companylogo",
      "Companyheader",
      "GetTokenLogs",
      "ShowWarningMessage",
      "AllPartnerList"
    ]),
    ...mapMutations(["setLoading"]),
    dateConvert: (value) => {
      return moment(String(value)).format("DD MMM YYYY");
    },
    toggleFilter() {
      this.showFilter = !this.ShowFilter;
    },
    closeFilter() {
      document.getElementById("dropdownMenuButton1").click();
      // this.showFilter = false;
    },
    selectFilter(option) {
      this.selectFilter = option;
    },
    async clearFilter() {
      this.selectedFilter = '';
      this.filters.partners = [];
      this.applyfilter = 0;
      await this.TokenLogDetails(this.filters.partners.join(','), this.fromDate, this.toDate);
      document.getElementById("dropdownMenuButton1").click();
    },
    async applyFilter() {
      document.getElementById("dropdownMenuButton1").click();
      await this.TokenLogDetails(this.filters.partners.join(','), this.fromDate, this.toDate);
    },
    async GetTokenLogsDetail() {
      var date = new Date();
      var endDate = moment(String(date)).add(1, 'days').format("YYYY-MM-DD  00:00:00");
      var startDate = moment(endDate, "YYYY-MM-DD").subtract(1, 'months').format("YYYY-MM-DD  00:00:00");
      this.fromDate = startDate;
      this.toDate = endDate;
      await this.TokenLogDetails(this.filters.partners.join(','), this.fromDate, this.toDate);
    },
    getTimezoneOffset() {
      const offsetMatch = this.user.timezone.match(/([+-]\d{2}):?(\d{2})?/);
      const hours = parseInt(offsetMatch[1]);
      const minutes = offsetMatch[2] ? parseInt(offsetMatch[2]) : 0;
      return hours * 60 + minutes;
    },
    timeZoneConvertDate(value) {
      const offset = this.getTimezoneOffset();
      const startTimeWithGMT = moment.utc(value).utcOffset(offset);
      return startTimeWithGMT.format("DD/MM/YYYY");
    },
    timeZoneConvertTime(value) {
      const offset = this.getTimezoneOffset();
      const startTimeWithGMT = moment.utc(value).utcOffset(offset);
      return startTimeWithGMT.format("HH:mm");
    },

    superadmin,

    myEventHandler(e) {
      this.screenWidth = window.outerWidth;
      e.preventDefault();
    },

    async TokenLogDetails(partners,to, from) {

      var filter = { clientPartnerIds: partners, fromDate: to, toDate: from };
      var tokenLogsResponse = await this.GetTokenLogs(filter);

      if (tokenLogsResponse.status) {
        var allRows = tokenLogsResponse.object.data;
        await this.tokensCount(allRows);
        if (this.selectedFilter === "Allocation") {
          this.tokenLogs = allRows.filter(x => x.transactionType === "allocation");
        }
        else if (this.selectedFilter === "Consumption") {
          this.tokenLogs = allRows.filter(x => x.transactionType === "consumption");
        }
        else {
          this.tokenLogs = allRows;
        }
      }

    },
    async tokensCount(allRows) {
      this.tokensAllocatedCount = allRows
        .filter(x => x.transactionType === "allocation")
        .reduce((count, x) => count + x.token, 0);

      this.tokensConsumedCount = allRows
        .filter(x => x.transactionType === "consumption")
        .reduce((count, x) => count + x.token, 0);

    },
    async PartnerList() {
      var partners = await this.AllPartnerList({
        clientId: this.clientId,
        offset: 0,
        limit: -1,
        Search: "",
      });
      this.partners = partners?.object?.data?.partnerData;
      this.partnersFilter = partners?.object?.data?.partnerData;
      this.clientsList = partners?.object?.data?.partnerData.map((i) => ({
        value: i.clientId,
        label: i.clientId + ' - ' + i.company,
      }));
    },
    // async addFilter(value, e) {
    //   if (e.target.checked) {
    //     if (this.filterTab == 1) {
    //       this.filters.partners.push(value);
    //     }

    //     this.applyfilter =
    //       this.filters.partners.length;
    //   } else {
    //     if (this.filterTab == 1) {
    //       this.filters.partners.splice(
    //         Object.freeze(
    //           JSON.parse(JSON.stringify(this.filters.partners))
    //         ).indexOf(value),
    //         1
    //       );
    //     }


    //     if (this.applyfilter == 1) {
    //       this.applyFilters();
    //     }
    //     this.applyfilter =
    //       this.filters.partners.length +
    //       this.filters.language.length +
    //       this.filters.invigilation.length;
    //   }
    //   console.log(this.partners);
    // },
    Filterresult() {
      if (this.searchfilter != "") {
        if (this.filterTab == 1) {
          this.partners = this.partnersFilter.filter((element) =>
            element.company
              .toLowerCase()
              .includes(this.searchfilter.toLowerCase())
          );
        }
      } else {
        this.partners = this.partnersFilter;

      }
    },

    addFilter(clientId, event) {
      if (event.target.checked) {
        if (!this.filters.partners.includes(clientId)) {
          this.filters.partners.push(clientId);
        }
        this.applyfilter = this.filters.partners.length;
      } else {
        const index = this.filters.partners.indexOf(clientId);
        if (index !== -1) {
          this.filters.partners.splice(index, 1);
        }
      }
    },


    encode(item) {
      return window.btoa(item);
    },
    //time-converter
    timeConverter(val) {
      const today = new Date(val);
      let h = today.getHours();
      let m = today.getMinutes();
      var meridian = h >= 12 ? "PM" : "AM";
      h = h % 12;
      h = h ? h : 12;
      m = m < 10 ? "0" + m : m;
      var strTime = h + ":" + m + " " + meridian;
      return strTime;
    },


    // async getData() {
    //   this.searchDisable = true;

    //   var list = await this.GetTokenAllocation({
    //     clientId: this.clientId,
    //     Page: this.page,
    //     Limit: this.limit,
    //     Search: this.filters.company,
    //   });
    //   this.searchDisable = false;
    //   var x = [];
    //   if (list != undefined) {
    //     this.tokenList = list.object.data.items;
    //     this.TokelistTotallength = list.object.data.totalItems;

    //     this.tokenList.forEach(async (element) => {
    //       x.push(element.clientId);
    //       var request = await this.requestedTokens({
    //         clientId: element.clientId,
    //       });
    //       if (request.status == false) {
    //         element.requestCount = 0;
    //       } else {
    //         element.requestCount = await request.object.data.length;
    //       }
    //     });
    //     this.Page_count = list.object.data.totalPages;
    //     this.partnerLogoList();
    //   }
    //   if (this.input.trim() != "") {
    //     list.Search = this.input;
    //   }
    // },

    async partnerLogoList() {
      this.tokenList.forEach(async (elm) => {
        var company = await this.Companyheader({
          clientId: elm.clientId,
        });
        var photo = company.object?.data?.profileImage;
        if (photo != null) {
          var resp = await this.companylogo({
            fileName: photo,
          });
          elm.photo = resp.object.data;
        } else {
          elm.photo = null;
        }
      });
    },

    // async incdrcTokens(modal, id) {
    //   await this.IncrOrDecTokens({
    //     clientId: id,
    //     amount: this.requestAmount,
    //   });
    //   this.requestAmount = 0;
    //   if (modal == "RequestToken_IncreaseTokenModal") {
    //     document.getElementById("closerequest").click();
    //     window.$("#RequestToken_IncreaseTokenModal").modal("hide");
    //   } else {
    //     document.getElementById("closerequest1").click();
    //     window.$("#RequestTokenModal").modal("hide");
    //   }
    //   this.getData();
    // },
    // async approverequest(reqId, status, index, tokenamount, id) {
    //   this.rejectrequest = await this.rejectReq({
    //     clientId: id,
    //     requestId: reqId,
    //     status: status,
    //     tokenAmount: tokenamount,
    //     company: this.modalData.company,
    //   });
    //   this.isActive = false;
    //   if (this.rejectrequest.status) {
    //     this.approvedReq.push(reqId);

    //     setTimeout(async () => {
    //       var request = await this.requestedTokens({
    //         clientId: id,
    //       });
    //       this.reqList = request.object.data;
    //       if (this.reqList.length == 0) {
    //         // document.getElementById('aprove').click();
    //         document.getElementById("closerequest").click();
    //       } else {
    //         this.reqList.forEach((element) => {
    //           if (element.tokenAmount > this.parentCompany.remainingToken) {
    //             this.redtext = true;
    //           } else {
    //             this.redtext = false;
    //           }
    //         });
    //       }
    //     }, 3000);
    //   } else {
    //     // this.parentCompany.remainingToken =
    //     //   this.parentCompany.remainingToken - tokenamount;
    //   }

    //   this.remainingToken = this.reqList[index].tokenAmount;
    //   // this.GetToken();
    //   this.getData();
    // },

    //   async rejectToken(reqId, status, tokenamount) {
    //     this.rejToken = await this.rejectReq({
    //       clientId: this.clientid,
    //       requestId: reqId,
    //       status: status,
    //       tokenAmount: tokenamount,
    //       company: this.modalData.company,
    //     });
    //     document.getElementById("remove").click();
    //     document.getElementById("closerequest").click();
    //     window.$("#RejectTokenModal").modal("hide");
    //     this.getData();
    //   },
    //  async GetToken() {
    //     var tokens = await this.GetTAllocation({
    //       clientId: this.clientId,
    //     });
    //     if (tokens != undefined) {
    //       this.parentCompany = tokens.object.data;

    //       this.parentCompanyName = this.parentCompany.company;
    //     }
    //   },
    opencal() {
      document.getElementById("calendar_icon").click();
    },

    checkBalance(amt) {
      Array.prototype.sum = function (prop) {
        var total = 0;
        for (var i = 0, len = this.length; i < len; i++) {
          total += this[i][prop];
        }
        return total;
      };
      var total = this.reqList.sum("tokenAmount");
      if (total > amt) return true;
      else return false;
    },

    openTokenModal(type) {
      if (type == 1) {
        this.modalData = this.parentCompany;
      }
      this.GetToken();
    },

    clearbtn() {
      this.AllocateAmount = null;
      this.requestAmount = null;
    },
    closeModal() {
      document.getElementById('closerequest').click();
    }
  },
};
</script>
<style scoped>
/* Base styles for all screens */
.filter-container {
  position: relative;
}

.filter-popup {
  position: absolute;
  top: 50px;
  right: 0;
  width: 250px;
  background: white;
  border-radius: 10px;
  z-index: 10;
}

.list-group-item {
  cursor: pointer;
  padding: 8px 12px;
}

.list-group-item:hover,
.list-group-item.active {
  background-color: #007bff;
  color: white;
}

/* css for rounding the tags in small screen */
.round-top-left-bottom-right {
  border-top-left-radius: 4.5px;
  border-bottom-right-radius: 4.5px;
}

/* 
  Target extra large screens (desktops)
  Use max-width for a more inclusive breakpoint 
*/
@media screen and (max-width: 1920px) {

  /* Styles for extra large screens */
  .float-end {
    float: right !important;
  }
}

/* 
  Target large screens (desktops)
*/
@media screen and (max-width: 1440px) {

  /* Styles for large screens */
  .float-end {
    float: right !important;
  }
}

/* 
  Target medium screens (tablets)
*/
@media screen and (max-width: 1024px) {

  /* Styles for medium screens */
  .float-end {
    float: right !important;
  }

  .container {
    font-size: 1rem;
  }

  .filter-popup {
    position: absolute;
    top: 50px;
    left: 0;
    width: 200px;
  }
}

/* 
  Target small screens (phones)
  Use min-width for a more precise breakpoint for tablets
*/
@media screen and (min-width: 768px) and (max-width: 1024px) {

  /* Styles for small screens (portrait tablets) */
  .container {
    font-size: .9rem;
  }

  .float-end {
    float: none !important;
    margin-bottom: 5%;
  }

  .filter-popup {
    font-size: .8rem;
    position: absolute;
    top: 50px;
    left: 0;
    width: 200px;
  }
}

/* 
  Target extra small screens (phones)
*/
@media screen and (max-width: 768px) {

  /* Styles for extra small screens (phones) */
  .container {
    font-size: .8rem;
  }

  .float-end {
    float: none !important;
    margin-bottom: 5%;
  }

  .filter-popup {
    font-size: .8rem;
    position: absolute;
    top: 50px;
    left: 0;
    width: 200px;
  }
}
</style>